export default __webpack_public_path__ + "static/media/023-no pork.f575ce52.svg";